import { action } from "typesafe-actions";
import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { api } from "../../api/api";
import {
	saveLoaderCompleted,
	saveLoaderProgress,
	showMessage,
} from "../messages/messagesActions";
import { IQueryParams } from "../common/common.types";
import { getSearchQuery } from "../common/helpers";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { IMetaData } from "./metaData.types";

// New Action Types
export const FETCH_USER_META_CONFIG_PROGRESS =
	"FETCH_USER_META_CONFIG_PROGRESS";
export const FETCH_USER_META_CONFIG_SUCCESS = "FETCH_USER_META_CONFIG_SUCCESS";
export const FETCH_USER_META_CONFIG_FAILED = "FETCH_USER_META_CONFIG_FAILED";

// New Action Creators
export const fetchUserMetaConfigProgress = () =>
	action(FETCH_USER_META_CONFIG_PROGRESS);
export const fetchUserMetaConfigSuccess = (data: any) =>
	action(FETCH_USER_META_CONFIG_SUCCESS, { data });
export const fetchUserMetaConfigFailed = () =>
	action(FETCH_USER_META_CONFIG_FAILED);

// New Async Actions
export const fetchUserMetaConfigAsync =
	(userUuid: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch) => {
		try {
			dispatch(fetchUserMetaConfigProgress());
			dispatch(saveLoaderProgress());
			const res = await api.get(
				`/user/get-user-meta-config?user_uuid=${userUuid}`
			);

			dispatch(fetchUserMetaConfigSuccess(res.data.data[0]));
		} catch (err: any) {
			dispatch(fetchUserMetaConfigFailed());
			dispatch(
				showMessage({
					type: "error",
					message: err.response.data.message,
					displayAs: "snackbar",
				})
			);
		} finally {
			dispatch(saveLoaderCompleted());
		}
	};

export const upsertUserMetaConfigAsync =
	(
		config: IMetaData,
		onCallback?: (isSuccess?: boolean, data?: any) => void
	): ThunkAction<void, IStoreState, {}, AnyAction> =>
	async (dispatch) => {
		dispatch(saveLoaderProgress());
		try {
			const {
				modified_by_name,
				modified_by_uuid,
				created_by_name,
				created_by_uuid,
				...rest
			} = config;
			const res = await api.post("/user/upsert-user-meta-config", {
				...rest,
			});
			dispatch(
				showMessage({
					type: "success",
					message: res.data.message,
					displayAs: "snackbar",
				})
			);
			const data = res.data.data;
			if (onCallback) {
				onCallback(true, data);
			}
		} catch (err: any) {
			if (onCallback) {
				onCallback(false);
			}
			dispatch(
				showMessage({
					type: "error",
					message: err.response.data.message,
					displayAs: "snackbar",
				})
			);
		} finally {
			dispatch(saveLoaderCompleted());
		}
	};

export const CLEAR_USER_META_CONFIG = "CLEAR_USER_META_CONFIG";
export const clearUserMetaConfig = () => action(CLEAR_USER_META_CONFIG);
